import React, { Component } from "react";

class PageIntro extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="page-intro-container">
                {this.props.TrumpetText && (
                    <p
                        className="page-intro__trumpet"
                        dangerouslySetInnerHTML={{ __html: this.props.TrumpetText }}
                    />
                )}
                {this.props.TitleText && !this.props.NotPrimaryHeader && (
                    <h1
                        className="page-intro__header content-module-header"
                        dangerouslySetInnerHTML={{ __html: this.props.TitleText }}
                    />
                )}
                {this.props.TitleText && this.props.NotPrimaryHeader && (
                    <h2
                        className="page-intro__header content-module-header"
                        dangerouslySetInnerHTML={{ __html: this.props.TitleText }}
                    />
                )}
                {this.props.DescriptionText && (
                    <div
                        className="page-intro__paragraph content-rich-text"
                        dangerouslySetInnerHTML={{ __html: this.props.DescriptionText }}
                    />
                )}
            </div>
        );
    }
}

export default PageIntro;
